import React from 'react';

const ForwardIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="m15 17 5-5-5-5"/>
            <path d="M4 18v-2a4 4 0 0 1 4-4h12"/>
        </svg>
    );
};

export default ForwardIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ForwardIcon.jsx